window.addEventListener('DOMContentLoaded', () => {
  const mediaItems = document.querySelectorAll('.Product__Media-Item');
  const zoomContainer = document.querySelector('.Product__NewZoom');
  const zoomBox = document.querySelector('.Product__NewZoom-Box');
  const zoomClose = document.querySelector('.Product__NewZoom-Close');

  mediaItems.forEach(item => {
    const isVideo = item.tagName === 'VIDEO';

    if(!isVideo) {
      item.addEventListener('click', () => {
        let source

          source = item.src

        console.log(source)

        zoomContainer.classList.add('active');


        const zoomImage = document.createElement('img');
        zoomImage.src = source;
        zoomImage.classList.add('Product__NewZoom-Image');
        zoomBox.appendChild(zoomImage);
      });
    }
  })

  zoomClose.addEventListener('click', () => {
    zoomContainer.classList?.remove('active');
    zoomBox.querySelector('.Product__NewZoom-Image')?.remove();
  });
})

// Close zoom in mobile
window.addEventListener('resize', () => {
  const zoomContainer = document.querySelector('.Product__NewZoom');
  const zoomBox = document.querySelector('.Product__NewZoom-Box');

  if(window.innerWidth <= 1024) {
    zoomContainer.classList?.remove('active');
    zoomBox.querySelector('.Product__NewZoom-Image')?.remove();
  }
})